import * as React from "react";

import { Button, message, Icon, Input, Select, Table, Tabs, Tooltip } from "antd";
// @ts-ignore
import CSVReader from '../csv-reader'
import styles from "./FeedSamples.module.less";
import { IFeed, FeedType, IFeedState, SampleFeedList, IActiveFeed } from "../../store/feed/types";
import { AdminZone } from "../AccessControl";
import {
    IDeleteFeedActionPayload,
    IModifyingActiveFeedActionPayload,
    ISelectFeedActionPayload
} from "../../store/feed/actions";

const { TabPane } = Tabs;
const { TextArea } = Input;
const { Option, OptGroup } = Select;

interface ICSVFeedSampleResult {
    data: SampleFeedList;
    meta: {
        fields: Array<string>;
    };
}

interface IOwnProps {
    feed: IFeedState;
    activeFeed: IActiveFeed;
    hasActiveFeedChanged: boolean;
}

interface ICallbackProps {
    onSaveFeed?: (feed: IFeed) => void;
    onSelectFeed?: (params: ISelectFeedActionPayload) => void;
    modifyingActiveFeed?: (params: IModifyingActiveFeedActionPayload) => void;
    deleteFeed?: (params: IDeleteFeedActionPayload) => void;
}

type IProps = IOwnProps & ICallbackProps

interface IState {
    activeTabKey: string;
}

class FeedSamples extends React.PureComponent<IProps, IState> {

    state: IState;

    constructor(props: Readonly<IProps>) {
        super(props);
        this.state = {
            activeTabKey: "json"
        }
    }

    handleForce = (result: ICSVFeedSampleResult, filename: any) => {
        if (this.props.modifyingActiveFeed) {
            this.props.modifyingActiveFeed({ feed: { preview: result.data } })
        }
    };

    handleDarkSideForce = (err: any) => {
        message.error(err)
    };

    editFeed = (e: any) => {
        if (this.props.modifyingActiveFeed) {
            this.props.modifyingActiveFeed({ feed: { json: e.target.value } })
        }

    };

    saveFeed = () => {
        if (!this.props.onSaveFeed) {
            return;
        }
        let feedPreview = this.props.activeFeed.preview
        if (this.state.activeTabKey === "json") {
            try {
                feedPreview = JSON.parse(this.props.activeFeed.json);
            } catch (e: any) {
                message.error(e.toString())
                return
            }
        }
        this.props.onSaveFeed({
            id: this.props.activeFeed.id,
            name: this.props.activeFeed.name,
            preview: feedPreview
        })
    }

    deleteFeed = () => {
        if (!this.props.deleteFeed) {
            return
        }
        this.props.deleteFeed({ id: this.props.activeFeed.id })
    }

    onTabChange = (activeKey: string) => {
        this.setState({
            activeTabKey: activeKey
        })
    }

    feedColumns = (): Array<Object> => {
        let feed = this.props.activeFeed
        if (feed.preview.length > 0) {
            return Object.keys(feed.preview[0]).map(function (field) {
                let render = (text: string) => <span>{text}</span>
                if (field === "ImageUrl") {
                    render = (text: string) => <Tooltip placement="top" title={text}><img src={text} width={100} /></Tooltip>
                }
                return {
                    title: field,
                    dataIndex: field,
                    key: field,
                    render: render
                }
            })
        }
        return []
    }

    jsonString = (): string => {
        try {
            const json = JSON.stringify(this.props.activeFeed.preview, null, 0);
            return json;
        } catch (e: any) {
            message.error(e.toString());
        }
        return ""
    }

    selectedFeed = (key: any, option: React.ReactElement<any>) => {
        if (this.props.onSelectFeed) {
            const feedType: FeedType = option.props['data-feed-type'];
            const selectFeed = this.props.feed[feedType].byId[key]
            this.props.onSelectFeed({ feed: selectFeed })
        }
    }

    updateNewFeedName = (e: any) => {
        if (this.props.modifyingActiveFeed) {
            this.props.modifyingActiveFeed({ feed: { name: e.target.value } })
        }
    }

    toggleAddingNewFeed = (e: any) => {
        if (this.props.modifyingActiveFeed) {
            this.props.modifyingActiveFeed({ feed: { id: "", name: "" } })
        }
    }

    render() {
        // console.log("FeedSamples render........")
        return (
            <div className={styles.innerContainer}>
                <Select
                    showSearch
                    defaultOpen={true}
                    onSelect={this.selectedFeed}
                    style={{ width: 320 }}
                    filterOption={(input, option) => {
                        if (option.props.children) {
                            return option.props.children.toLocaleString().indexOf(input.toLowerCase()) >= 0

                        }
                        return true
                    }}
                >
                    <OptGroup label="Live Feeds">
                        {

                            Object.values(this.props.feed.liveFeeds.byId).sort((a, b) => a.name.localeCompare(b.name)).map(function (feed: IFeed) {
                                return (
                                    <Option
                                        data-feed-type={FeedType.LIVE}
                                        key={feed.id}
                                        value={feed.id}
                                    >
                                        {feed.name}
                                    </Option>
                                );
                            })
                        }
                    </OptGroup>
                    <OptGroup label="Sample Feeds">
                        {

                            Object.values(this.props.feed.sampleFeeds.byId).sort((a, b) => a.name.localeCompare(b.name)).map(function (feed: IFeed) {
                                return (
                                    <Option
                                        data-feed-type={FeedType.SAMPLE}
                                        key={feed.id}
                                        value={feed.id}
                                    >
                                        {feed.name}
                                    </Option>
                                );
                            })
                        }
                    </OptGroup>
                </Select>
                <Button
                    onClick={this.toggleAddingNewFeed}
                >
                    <Icon type="plus" /> Add New Sample Feed
                </Button>
                <div className={styles.feedName}>
                    <span>Sample Feed Name:</span>
                    <Input
                        placeholder="Sample Feed name"
                        onChange={this.updateNewFeedName}
                        value={this.props.activeFeed.name}
                    />
                </div>
                <Tabs
                    animated={false}
                    defaultActiveKey="json"
                    activeKey={this.state.activeTabKey}
                    onChange={this.onTabChange}
                    size="small"
                >
                    <TabPane tab="JSON" key="json">
                        <TextArea
                            rows={10}
                            value={this.props.activeFeed.json}
                            onChange={this.editFeed}
                        />
                    </TabPane>
                    <TabPane tab="CSV" key="csv">
                        <CSVReader
                            cssClass="csv-reader-input"
                            label="Upload sample feed from csv file... Maximum 20KB."
                            parserOptions={{ header: true, skipEmptyLines: true }}
                            onFileLoaded={this.handleForce}
                            onError={this.handleDarkSideForce}
                            // inputId="ObiWan"
                            inputStyle={{ color: 'red' }}
                        />
                        <a href={process.env.PUBLIC_URL + '/media/sample.csv'}>You can try with this example.</a>
                        <pre>{this.jsonString()}</pre>
                    </TabPane>
                </Tabs>
                <AdminZone>
                    <Button
                        type={"primary"}
                        disabled={!this.props.hasActiveFeedChanged || this.props.activeFeed.name === ""}
                        className={styles.saveFeedButton}
                        onClick={this.saveFeed}
                    >
                        {this.props.activeFeed.id === "" ? "Create" : "Update"}
                    </Button>
                    {this.props.activeFeed.id !== "" &&
                        <Button
                            style={{ marginLeft: 10 }}
                            onClick={this.deleteFeed}
                        >
                            Delete
                        </Button>
                    }
                </AdminZone>

                <Table
                    dataSource={this.props.activeFeed.preview}
                    columns={this.feedColumns()}
                    rowKey="Id"
                    scroll={{ x: true }}
                    pagination={{ pageSize: 3, position: "top" }}
                />
            </div>
        )
    }
}

export default FeedSamples;

